'use client'

import Link from 'next/link'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html lang="en">
      <head>
        <title>Error - Alex Malott</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </head>
      <body
        style={{
          margin: 0,
          padding: 0,
          fontFamily: 'ui-monospace, "Geist Mono", monospace',
          background: 'oklch(0.12 0.02 145)',
          color: 'oklch(0.85 0.15 145)',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            maxWidth: '600px',
            padding: '48px 24px',
            textAlign: 'center',
          }}
        >
          <div
            style={{
              fontSize: '64px',
              fontWeight: 'bold',
              marginBottom: '24px',
              textShadow: '0 0 16px oklch(0.85 0.15 145 / 0.5)',
            }}
          >
            ⚠
          </div>
          <h1
            style={{
              fontSize: '32px',
              fontWeight: 'bold',
              marginBottom: '16px',
              letterSpacing: '-0.025em',
              textShadow: '0 0 16px oklch(0.85 0.15 145 / 0.35)',
            }}
          >
            Application Error
          </h1>
          <p
            style={{
              fontSize: '18px',
              marginBottom: '24px',
              color: 'oklch(0.65 0.1 145)',
            }}
          >
            A critical error occurred. This has been logged for investigation.
          </p>
          {error.digest && (
            <p
              style={{
                fontSize: '14px',
                fontFamily: 'ui-monospace, monospace',
                color: 'oklch(0.5 0.08 145)',
                marginBottom: '32px',
              }}
            >
              Error ID: {error.digest}
            </p>
          )}
          <div
            style={{
              display: 'flex',
              gap: '16px',
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}
          >
            <button
              onClick={reset}
              style={{
                padding: '12px 24px',
                fontSize: '16px',
                fontWeight: '500',
                background: 'oklch(0.85 0.15 145 / 0.15)',
                color: 'oklch(0.85 0.15 145)',
                border: '1px solid oklch(0.85 0.15 145 / 0.4)',
                borderRadius: '6px',
                cursor: 'pointer',
                transition: 'all 0.2s',
                fontFamily: 'inherit',
              }}
            >
              Try Again
            </button>
            <Link
              href="/"
              style={{
                padding: '12px 24px',
                fontSize: '16px',
                fontWeight: '500',
                background: 'oklch(0.85 0.15 145)',
                color: 'oklch(0.12 0.02 145)',
                border: '1px solid oklch(0.85 0.15 145)',
                borderRadius: '6px',
                textDecoration: 'none',
                display: 'inline-block',
                transition: 'all 0.2s',
              }}
            >
              Return Home
            </Link>
          </div>
        </div>
      </body>
    </html>
  )
}
